
<template>
  <el-main :class="$route.name">
 
    <RouterView />
  </el-main>
</template>

<script setup >
import { RouterView } from 'vue-router'

</script>